import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { apiUrl, getErrorMessage } from '../utils/api';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo') || '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post(apiUrl('/api/auth/login'), { email, password });
      if (response.data.code === 'TWO_FACTOR_SETUP_REQUIRED') { localStorage.setItem('twoFactorPending', JSON.stringify({ setupToken: response.data.setupToken, name: response.data.name, email: response.data.email })); navigate('/security'); return; }
      if (response.data.code === 'TWO_FACTOR_REQUIRED') { localStorage.setItem('twoFactorPending', JSON.stringify({ twoFactorToken: response.data.twoFactorToken, name: response.data.name, email: response.data.email })); navigate('/two-factor'); return; }
      localStorage.removeItem('twoFactorPending');
      localStorage.setItem('userInfo', JSON.stringify(response.data));
      window.dispatchEvent(new Event('authchange'));
      const pendingAppointment = JSON.parse(localStorage.getItem('pendingAppointment') || 'null');
      const safeReturnTo = returnTo.startsWith('/') ? returnTo : '';
      navigate(response.data.role === 'staff' || response.data.businessRoles?.some(m => m.role === 'staff') ? '/my-schedule' : safeReturnTo || (pendingAppointment?.form?.businessSlug ? `/appointment?business=${encodeURIComponent(pendingAppointment.form.businessSlug)}` : '/dashboard'));
    } catch (err) {
      setError(getErrorMessage(err, 'Login failed. Check the account details and confirm MongoDB is reachable.'));
    }
  };

  return (
    <div className="page auth-page">
      <form className="panel auth-card" onSubmit={handleSubmit}>
        <p className="eyebrow">Welcome back</p>
        <h1>Login</h1>
        <p className="muted-text login-role-hint">Owners, managers, and professionals use this same login and are taken to their business tools automatically.</p>
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <button type="submit">Login</button>
        {error && <p className="error-message">{error}</p>}
        <div className="auth-links">
          <div className="first-time-register"><strong>First time booking?</strong><Link className="button primary" to={returnTo ? `/register?returnTo=${encodeURIComponent(returnTo)}` : "/register"}>Register here</Link></div><p className="muted-text">Already have an account? Log in above.</p>
          <p className="muted-text"><Link to="/forgot-password">Forgot password?</Link></p>
        </div>
      </form>
    </div>
  );
}

export default Login;
